import React from 'react'
import ImageComparisonSpace from './ImageComparisonSpace'
import c from './ImageComparison.module.scss'

interface ImageComparisonProps {
  imageUrl: string
  sourceUrl: string
}

function ImageComparison({ imageUrl, sourceUrl }: ImageComparisonProps) {
  return (
    <div className={c.container}>
      <ImageComparisonSpace imageUrl={imageUrl} sourceUrl={sourceUrl} />
    </div>
  )
}

export default ImageComparison